import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/**
 * Global API that contains all endpoints of the @rcm/redux-global store
 */
const globalApi = createApi({
    baseQuery: fetchBaseQuery(),
    endpoints: () => ({}),
});

export default globalApi;
